import React, { useContext } from 'react';
import { EventDetailsContext } from '../../context/event_details.context';
import styles from './fixed_bottom_cta.module.scss';
import CtaSection from '../cta_section/cta_section';

const FixedBottomCta: React.FC = () => {
  const { event, onCtaClick, isSignedIn, isLoading } =
    useContext(EventDetailsContext);
  if (!event) return null;
  if (!event.registration_open || event.is_current_user_attending) return null;

  const renderDesktopCtaButton: JSX.Element = (
    <div className='row d-none align-items-center d-md-flex my-35 mx-0'>
      <div className='col px-1'>
        <h1 className={styles.heading}>{event?.title}</h1>
      </div>

      <div className='col-auto px-1'>
        <CtaSection position='end' />
      </div>
    </div>
  );

  const renderMobileCtaButton: JSX.Element = (
    <div className='container'>
      <div
        className={`row ${isSignedIn ? 'd-block d-md-none' : 'd-none'} my-4`}
      >
        <div className='col-auto'>
          <button
            type='button'
            onClick={onCtaClick}
            disabled={isLoading}
            aria-label='register-mobile-button'
            className='w-100 fs-5 py-2 btn btn-primary'
          >
            Save your spot now
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className={`fixed-bottom ${styles.fixedBottom}`}>
      <div className={`px-0 container ${styles.limitedWidthForContainer}`}>
        {renderDesktopCtaButton}
        {renderMobileCtaButton}
      </div>
    </div>
  );
};

export default FixedBottomCta;
